/**
 * 将二进制转成指定文件下载
 * @params {Blob} data 二进制数据
 * @params {String} fileName 文件名（包含后缀）
 */
export function downloadBlobFile(data, fileName) {
  const blob = new Blob([data])

  // 兼容IE浏览器
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName)
    return
  }

  const a = document.createElement('a')
  a.download = fileName
  a.href = URL.createObjectURL(blob)
  document.body.appendChild(a)
  a.click()
  URL.revokeObjectURL(a.href)
  document.body.removeChild(a)
}

/**
 * 获取url参数的值
 * @param {String} variable
 */

export function getQueryVariable(variable) {
  // 获取除去？的url参数部分
  var query = window.location.search.substring(1)
  // 字符串切割成数组
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}

/**
 * 加载script脚本
 */
export const loadScript = (function() {
  const cache = []
  return function(src, successCb, options = { cache: true }) {
    if (cache.includes(src)) return
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = src
    document.body.appendChild(script)
    successCb && script.addEventListener('load', successCb)
    options.cache && cache.push(src)
  }
})()

export function largeHump(string) {
  try {
    return string.split(' ').map(s => s.trim()).map(s => s[0].toUpperCase() + s.substring(1)).join(' ')
  } catch (error) {
    return string
  }
}

export function UrlSearch() {
  let str = location.search.substr(1).split('&')
  let obj = {}
  str.forEach(e => {
    let list = e.split('=')
    obj[list[0]] = list[1]
  })
  return obj
}

// 存储
export function setStorage(key, value, sTime) {
  let obj = {
    data: value,
    time: Date.now(),
    storageTime: sTime
  }
  window.localStorage.setItem(key, JSON.stringify(obj))
}

// 取值
export function getStorage(key) {
  let obj = window.localStorage.getItem(key)
  obj = JSON.parse(obj)
  if (obj === null || (Date.now() - obj.time > obj.storageTime)) {
    window.localStorage.removeItem(key)
    return null
  }
  return obj.data
}

/**
 * 添加URL参数
 *
 * @param {String} url url
 * @param {String} key key值
 * @param {String} value 参数值
 * @returns 添加的结果
 */
export function AddUrlParm(url, key, value) {
  let returnUrl = ''
  if (url.indexOf('?') === -1) {
    returnUrl += url + '?' + key + '=' + value
  } else {
    if (url.indexOf('?' + key + '=') === -1 && url.indexOf('&' + key + '=') === -1) {
      returnUrl += url + '&' + key + '=' + value
    } else {
      let isDone = false
      let startIndex = 0
      let endIndex = url.length - 1
      let parm = '?' + key + '='
      for (let i = 0; i < url.length; i++) {
        if (url.substr(i, parm.length) === parm) {
          startIndex = i + parm.length
          for (let j = startIndex; j < url.length; j++) {
            if (url[j] === '&') {
              endIndex = j
              break
            } else if (j === url.length - 1) {
              endIndex = url.length
            }
          }
          isDone = true
          break
        }
      }
      if (!isDone) {
        parm = '&' + key + '='
        for (let i = 0; i < url.length; i++) {
          if (url.substr(i, parm.length) === parm) {
            startIndex = i + parm.length
            for (let j = startIndex; j < url.length; j++) {
              if (url[j] === '&') {
                endIndex = j
                break
              } else if (j === url.length - 1) {
                endIndex = url.length
              }
            }
            break
          }
        }
      }
      let parmKeyValue = parm + url.substring(startIndex, endIndex)
      returnUrl = url.replace(parmKeyValue, parm + value)
    }
  }
  return returnUrl
}
